<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Update Coupon</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Update Coupon</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div class="" formArrayName="newCouponGroups">
            <div class="p-3 p-md-4 mb-3">
                <div class="p-3 mb-md-4 position-relative" *ngFor="let item of newCouponGroups().controls; let i=index"
                    [formGroupName]="i">

                    <div class="row row-gap-4">
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group mb-0 w-100">
                                <div class="col-5 d-flex">
                                    <div class="form-check mr-4">
                                        <input type="radio" class="form-check-input" value="Generic"
                                            formControlName="coupontype" id="Generic"
                                            [checked]="originalCouponType=='Generic'"
                                            [(ngModel)]="couponsection.coupontype">
                                        <label for="Generic" class="form-check-label">Generic</label>
                                    </div>
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" value="Brands"
                                            formControlName="coupontype" id="Brands"
                                            [checked]="originalCouponType=='Brands'"
                                            [(ngModel)]="couponsection.coupontype">
                                        <label for="Brands" class="form-check-label">Brands</label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('coupontype').invalid && newCouponGroups().controls[i].get('coupontype').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('coupontype').errors?.required">
                                        Coupon Type is required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row row-gap-4">
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="title" id="title" class="form-control"
                                    placeholder="Title" [(ngModel)]="couponsection.title">
                                <label>
                                    Title
                                </label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('title').invalid && newCouponGroups().controls[i].get('title').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('title').errors?.required">
                                        Title is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input class="cal-icon form-control" autocomplete="off" (click)="d1.toggle()"
                                    (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedDate($event)"
                                    id="startdate" type="text" formControlName="startdate" ngbDatepicker
                                    #d1="ngbDatepicker" [minDate]="minDate" [(ngModel)]="couponsection.startdate"
                                    required>
                                <label>
                                    Start Date
                                </label>
                                <!-- <div class="col-2 pt-2">
                                        <div class="text-small">Start Date</div>
                                        <span class="title-text">{{formatDate}}</span>
                                    </div> -->
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('startdate').invalid && newCouponGroups().controls[i].get('startdate').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('startdate').errors?.required">
                                        Start Date is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input class="cal-icon form-control" autocomplete="off" (click)="d2.toggle()"
                                    (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedToDate($event)"
                                    id="enddate" type="text" formControlName="enddate" ngbDatepicker #d2="ngbDatepicker"
                                    [minDate]="minDate" [(ngModel)]="couponsection.enddate" required>
                                <label>
                                    End Date
                                </label>
                                <!-- <div class="col-2 pt-2">
                                        <div class="text-small">End Date</div>
                                        <span class="title-text">{{formatToDate}}</span>
                                    </div> -->
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('enddate').invalid && newCouponGroups().controls[i].get('enddate').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('enddate').errors?.required">
                                        End Date is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="couponvalue" id="couponvalue" class="form-control"
                                    placeholder="Value in(₹)" [(ngModel)]="couponsection.couponvalue">
                                <label>
                                    Value in(₹)
                                </label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('couponvalue').invalid && newCouponGroups().controls[i].get('couponvalue').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('couponvalue').errors?.required">
                                        Coupon Value is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="couponcount" id="couponcount" class="form-control"
                                    placeholder="Coupon Count" [(ngModel)]="couponsection.couponcount">
                                <label>
                                    Coupon Count
                                </label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('couponcount').invalid && newCouponGroups().controls[i].get('couponcount').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('couponcount').errors?.required">
                                        Coupon Count is required
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="coupondetails" id="coupondetails"
                                    class="form-control" placeholder="Coupon Details"
                                    [(ngModel)]="couponsection.coupondetails">
                                <label>
                                    Coupon Detail
                                </label>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div *ngIf="newCouponGroups().controls[i].get('coupondetails').invalid && newCouponGroups().controls[i].get('coupondetails').touched"
                                    class="small text-danger">
                                    <div *ngIf="newCouponGroups().controls[i].get('coupondetails').errors?.required">
                                        Coupon Detail is required
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="d-flex align-items-center justify-content-between upload_field"
                                (click)="uploadImages.click()">
                                <span>Upload Logo</span>
                                <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                            </div>
                            <input onclick="this.value = null" formControlName="couponimage" id="couponimage"
                                type="file" class="d-none" accept=".png, .jpg, .jpeg" (change)="onFileChange($event)"
                                #uploadImages>

                            <div *ngIf="newCouponGroups().controls[i].get('couponimage').invalid && newCouponGroups().controls[i].get('couponimage').touched"
                                class="small text-danger">
                                <div *ngIf="newCouponGroups().controls[i].get('couponimage').errors?.required">
                                    Coupon Image is required
                                </div>
                            </div>
                        </div>

                    </div>

                    <!--  <div class="row row-gap-4">
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                            <div class="form-group mb-0 w-100">
                                <div class="col-5 d-flex">
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                
                            </div>
                        </div>
                    </div> -->

                    <!-- <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                        <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                    </button> -->
                </div>
            </div>
        </div>
        <!-- <div>
            <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
        </div> -->

        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>